import api from "./api";

export interface Notification {
  id: number;
  _id: number;
  title: string;
  description: string;
  user_id: number;
  user_name: string;
  created_at: string;
}

export interface CreateNotificationPayload {
  title: string;
  description: string;
  user_id: number;
}

export interface CreateNotificationAllPayload {
  title: string;
  description: string;
  only_expired?: boolean;
}

async function create(payload: CreateNotificationPayload): Promise<Notification | null> {
  try {
    const { data } = await api.post(`/notifications/create/`, payload);
    return data;
  } catch (e) {
    console.error("Erro ao criar notificação:", e);
    return null;
  }
}

async function createAll(
  payload: CreateNotificationAllPayload
): Promise<{ message: string; notifications: Notification[]; count: number } | null> {
  try {
    const { data } = await api.post(`/notifications/create-all/`, payload);
    return data;
  } catch (e) {
    console.error("Erro ao criar notificações para todos:", e);
    return null;
  }
}

async function listByUser(user_id: string | number): Promise<Notification[]> {
  try {
    const { data } = await api.get(`/notifications/user/${user_id}/`);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("Erro ao listar notificações:", e);
    return [];
  }
}

const notifications = {
  create,
  createAll,
  listByUser,
};

export default notifications;
